var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lista-acciones"},[_c('ol',{staticClass:"lista"},_vm._l((_vm.filterDataBase),function(list,idx){return _c('ListV2',{key:`accion_${idx}`,attrs:{"meta":list.linea_estrategica,"submetas":list.componente}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }